import {Injectable} from '@angular/core';

@Injectable()
export class LocalStorageService {

    constructor() {
    }

    saveData(data) {
        window.localStorage.setItem('wizardForm', JSON.stringify(data));
    }

    loadData() {
        return JSON.parse(window.localStorage.getItem('wizardForm'));
    }

    isSaved() {
        return !!window.localStorage.getItem('wizardForm');
    }

    clear() {
        window.localStorage.removeItem('wizardForm');
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-apps-saas/src/app/shared/local-storage.service.ts